import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { BookOpen, Palette, Heart, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CopertiPiele = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-20">
        {/* Hero Section */}
        <section className="relative py-32 pb-24 overflow-hidden bg-gradient-to-br from-leather/10 via-accent/5 to-background">
          <div className="absolute inset-0">
            <div className="absolute top-20 right-10 w-[500px] h-[500px] bg-accent/10 rounded-full blur-3xl animate-float"></div>
            <div className="absolute bottom-20 left-10 w-96 h-96 bg-leather/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
          </div>

          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-5xl mx-auto text-center">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent/10 backdrop-blur-sm border border-accent/20 rounded-full mb-8 animate-fade-in">
                <BookOpen className="w-5 h-5 text-accent" />
                <span className="text-accent font-semibold text-sm font-lora">Artă personalizată</span>
              </div>

              <h1 className="text-6xl md:text-8xl font-bold text-primary mb-8 animate-fade-in font-playfair leading-tight" style={{ animationDelay: '0.2s' }}>
                Coperți din piele
              </h1>

              <p className="text-xl md:text-3xl text-muted-foreground mb-8 animate-fade-in font-lora leading-relaxed max-w-4xl mx-auto" style={{ animationDelay: '0.4s' }}>
                Cărțile de suflet, albumele de artă, de fotografii, jurnalele, agendele cu însemnări pot 
                deveni obiecte unicat care să poarte amprenta lucrului de mână și a originalității.
              </p>

              <Link to="/magazin">
                <Button size="lg" className="animate-fade-in hover-scale hover-glow shadow-2xl text-lg px-10 py-7 rounded-full bg-primary hover:bg-primary/90" style={{ animationDelay: '0.6s' }}>
                  <Palette className="w-5 h-5 mr-2" />
                  Explorează colecția
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-24 bg-gradient-to-b from-background to-cream/20">
          <div className="container mx-auto px-4">
            <div className="max-w-5xl mx-auto space-y-16">
              {/* Intro */}
              <div className="bg-card/90 backdrop-blur-sm rounded-[2rem] p-10 md:p-16 border-2 border-border/50 shadow-2xl animate-fade-in relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-accent/5 rounded-full blur-3xl"></div>
                
                <div className="flex items-start gap-6 mb-6 relative">
                  <div className="w-16 h-16 bg-accent/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <Sparkles className="w-8 h-8 text-accent" />
                  </div>
                  <div>
                    <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-playfair">
                      Activitatea noastră
                    </h2>
                    <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-lora">
                      La cererea dvs., vom creea și vom executa în cadrul atelierelor <strong>Idaco …dar din har…</strong> 
                      coperțile din piele pe care vi le imaginați.
                    </p>
                  </div>
                </div>
              </div>

              {/* Albume despre România */}
              <div className="bg-gradient-to-br from-leather/10 to-accent/10 rounded-[2rem] p-10 md:p-16 border-2 border-accent/20 animate-fade-in relative overflow-hidden" style={{ animationDelay: '0.2s' }}>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl"></div>
                
                <h3 className="text-3xl md:text-4xl font-bold text-primary mb-8 font-playfair relative">
                  Albume despre România
                </h3>
                <p className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed font-lora relative">
                  În cadrul atelierelor <strong>Idaco …dar din har…</strong> am creat o serie de albume având 
                  teme românești, executând coperți din piele în relief, pictate manual. O parte din ele au 
                  fost donate Bibliotecii Naționale a României „ Dimitrie Cantemir" din Chișinău, secția de 
                  cărți rare.
                </p>
                <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-lora relative">
                  Albumele sunt organizate astfel: imagini de arhivă alb-negru, mărturii documentare 
                  (fragmente din cărți, din reviste de epocă, scrisori) și imagini de ultimă oră făcute de 
                  fotografi contemporani pentru a evidenția cât mai bine ceea ce a mai rămas din monumentele 
                  amintite.
                </p>
              </div>

              {/* Tipuri de albume */}
              <div className="grid md:grid-cols-2 gap-10">
                <div className="p-10 bg-card/90 backdrop-blur-sm rounded-2xl border-2 border-border/50 hover:border-accent/30 transition-all duration-500 hover-scale hover:shadow-2xl animate-fade-in group" style={{ animationDelay: '0.3s' }}>
                  <Heart className="w-12 h-12 text-gold mb-6 group-hover:scale-110 transition-transform" />
                  <h4 className="text-2xl md:text-3xl font-bold text-primary mb-4 font-playfair">
                    Albume personalizate
                  </h4>
                  <p className="text-muted-foreground font-lora text-lg leading-relaxed">
                    Creăm coperți din piele pentru albumele de familie, de artă sau colecții personale, 
                    fiecare fiind unică și adaptată dorințelor dumneavoastră.
                  </p>
                </div>

                <div className="p-10 bg-card/90 backdrop-blur-sm rounded-2xl border-2 border-border/50 hover:border-accent/30 transition-all duration-500 hover-scale hover:shadow-2xl animate-fade-in group" style={{ animationDelay: '0.4s' }}>
                  <BookOpen className="w-12 h-12 text-gold mb-6 group-hover:scale-110 transition-transform" />
                  <h4 className="text-2xl md:text-3xl font-bold text-primary mb-4 font-playfair">
                    Cărți bibliofile
                  </h4>
                  <p className="text-muted-foreground font-lora text-lg leading-relaxed">
                    Oferim servicii complete de recoperta și restaurare pentru cărți prețioase, 
                    jurnale și agende cu însemnări importante.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-gradient-to-br from-accent/10 via-leather/5 to-background relative overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute top-20 left-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-float"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-leather/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
          </div>

          <div className="container mx-auto px-4 relative text-center">
            <h2 className="text-5xl md:text-6xl font-bold text-primary mb-8 font-playfair animate-fade-in">
              Creăm împreună coperți unicat
            </h2>

            <p className="text-xl md:text-2xl text-muted-foreground max-w-4xl mx-auto mb-10 font-lora animate-fade-in leading-relaxed" style={{ animationDelay: '0.2s' }}>
              Fie că doriți să îmbrăcați în piele o carte de suflet sau un album special, 
              suntem aici să materializăm ideile dumneavoastră.
            </p>

            <Link to="/#contact">
              <Button size="lg" className="animate-fade-in hover-scale hover-glow shadow-2xl text-lg px-10 py-7 rounded-full bg-primary hover:bg-primary/90" style={{ animationDelay: '0.4s' }}>
                <Heart className="w-5 h-5 mr-2" />
                Contactează-ne
              </Button>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CopertiPiele;
